import { FC } from 'react';
import { localeStore } from '~/mobx/localesStore';
import Button from '~/view/components/Controls/ButtonComponent/Button';

interface IProps {
  showDelete: boolean;
  onSave: () => void;
  onDelete: () => void;
}

const PromocodeActions: FC<IProps> = ({ showDelete, onSave, onDelete }): JSX.Element => {
  return (
    <div className="d-flex gap-20 mt-8">
      <Button title={localeStore.t('Save')} onClick={onSave} />
      {showDelete && <Button title={localeStore.t('txt_delete')} appearance="destructive-tertiary" onClick={onDelete} />}
    </div>
  );
};

export default PromocodeActions;
